/** Discover → Tools (AUTO-8). Thin wrapper around <CatalogBrowsePage>. */

import { createFileRoute } from '@tanstack/react-router';
import { Wrench } from 'lucide-react';
import { CatalogBrowsePage } from '@/components/discover/catalog-browse-page';

export const Route = createFileRoute('/admin/discover/tools')({
  component: DiscoverToolsPage,
});

function DiscoverToolsPage() {
  return (
    <CatalogBrowsePage
      kind="tool"
      title="Tools"
      description="Function-callable capabilities the LLM can invoke. System tools are platform-shipped (search_knowledge, current_time, etc.); tenant tools are wired via Connections."
      icon={Wrench}
    />
  );
}
